import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * SEO component for managing page metadata
 * @param {string} title - Page title
 * @param {string} description - Page description
 * @param {string} image - OG image URL
 * @param {string} url - Canonical URL
 */
export const SEO = ({ 
  title = 'Veitvet Sportsklubb', 
  description = 'Veitvet Sportsklubb - din lokale idrettsklubb i bydel Bjerke, Oslo. Fotball, tennis, dans og pilates for alle aldre.', 
  image = 'https://customer-assets.emergentagent.com/job_a2119276-b11a-4d90-b267-fc420228fa77/artifacts/alzqtyc1_VSK%20logo_1.png',
  url = ''
}) => {
  const fullTitle = title === 'Veitvet Sportsklubb' 
    ? title 
    : `${title} | Veitvet Sportsklubb`;

  useEffect(() => {
    document.title = fullTitle;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', description);
  }, [fullTitle, description]);

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />
      {url && <meta property="og:url" content={url} />}
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="Norwegian" />
      <meta name="geo.region" content="NO-03" />
      <meta name="geo.placename" content="Oslo" />
      
      {/* Canonical URL */}
      {url && <link rel="canonical" href={url} />}
    </Helmet>
  );
};

export default SEO;
